module.exports = __webpack_public_path__ + "media/images/shared/avatar-default-7467912d66c3b5e69b8f1b1a1f7eabb0.png";